export enum EUserTariffStatus {
    blocked = 'blocked',
    active = 'active',
    pending = 'pending',
}
